function getCart() {
  return fetch("/cart.js").then((response) => response.json());
}

const aa2sa_btn = document.querySelector('.aa2sa')




var productsToFetch = [
  { id: "49503038538057", quantity: 1 },
  // blood test
  {
    id: "49503043912009",
    quantity: 1,
    selling_plan: "689928896841",
    properties: {
      _linked_product: "49503038538057",
    },
  }, // sub (monthly)
  {
    id: "50601274835273",
    quantity: 1,
    selling_plan: "689924440393",
    properties: {
      _linked_product: "49503038538057",
    },
  }, // yearly
];
// window.onload = () =>{
window.addEventListener("DOMContentLoaded", (event) => {
  const tabber2 = document.querySelector(".tabber");

  if (tabber2) {
    let currentID = null;
    let uniqueTabValues = [];

    tabActivator();
    tabBtnHandleClick();

    function tabActivator() {
      const allSectionsWithTabIdentificator =
        tabber2.querySelectorAll("[tabber-id]") || [];
      if (allSectionsWithTabIdentificator.length == 0) return;

      const tabValues = [];

      allSectionsWithTabIdentificator.forEach((section) => {
        const value = section.getAttribute("tabber-id");
        tabValues.push(value);
      });

      uniqueTabValues = [...new Set(tabValues)];

      // TO DO / Read first button id
      currentID = uniqueTabValues[1];

      console.log(uniqueTabValues);
      // debugger

      tabSectionToggle(currentID);
      tabBtnHandleClick();
    }
    function tabBtnHandleClick() {
      const allTabBtns = document.querySelectorAll("[tabber-href]") || [];
      if (allTabBtns.length == 0) return;
      allTabBtns.forEach((allTabBtn) => {
        const value = allTabBtn.getAttribute("tabber-href");

        allTabBtn.onclick = (event) => {
          if (value && value.length > 0) {
            currentID = value;
          }

          allTabBtns.forEach((button) => {
            if (event.currentTarget === button) {
              button.classList.add("active");
            } else {
              button.classList.remove("active");
            }
          });

          tabSectionToggle(currentID);
        };
      });
    }
    function tabSectionToggle(id) {
      const allSectionsWithTabIdentificator =
        tabber2.querySelectorAll("[tabber-id]") || [];
      const foundTabsWithIdentificators =
        tabber2.querySelectorAll(`[tabber-id="${id}"]`) || [];
      if (allSectionsWithTabIdentificator.length == 0) return;

      allSectionsWithTabIdentificator.forEach((section) => {
        const value = section.getAttribute("tabber-id").toLowerCase();
        if (value.includes(id.toLowerCase())) {
          section.classList.remove("hidden_section");
        } else {
          section.classList.add("hidden_section");
        }
      });

      // allSectionsWithTabIdentificator.forEach(section => {
      //     section.classList.add('hidden_section')
      //   })
      //   foundTabsWithIdentificators.forEach(section => {
      //     section.classList.remove('hidden_section')
      //   })
      // if(uniqueTabValues[0] !== id){

      //   // allSectionsWithTabIdentificator.forEach(section => {
      //   //   section.classList.add('hidden_section')
      //   // })
      //   foundTabsWithIdentificators.forEach(section => {
      //     section.classList.remove('hidden_section')
      //   })
      // }else{
      //   allSectionsWithTabIdentificator.forEach(section => {
      //     section.classList.add('hidden_section')
      //   })
      //   foundTabsWithIdentificators.forEach(section => {
      //     section.classList.remove('hidden_section')
      //   })
      // }
    }
  }
  // tabber-id

  const l = new Swiper(".swiperP", {
    // speed: 400,
    spaceBetween: 20,
    allowTouchMove: false,
  });
  const p = new Swiper(".swiper2", {
    // speed: 400,
    // spaceBetween: 20,
    // thumbs: {
    //   swiper: l ? l : null,
    // },
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });

  const collageSlider = new Swiper(".collage-slider", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    slidesPerView: 1.1,
    spaceBetween: 20,
  });

  const swiper = new Swiper(".review-slider-swiper", {
    // Optional parameters
    direction: "horizontal",
    loop: false,
    slidesPerView: 3.2,
    spaceBetween: 20,

    // pagination: {
    //   el: '.swiper-pagination',
    // },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // And if we need scrollbar
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.25,
      },
      1000: {
        slidesPerView: 3.2,
      },
    },
  });

  // gsap.registerPlugin(ScrollTrigger);

  // let revealContainers = document.querySelectorAll(".reveal");

  // let titleReveal = document.querySelectorAll(".title_reveal");

  // revealContainers.forEach((container) => {
  //   let image = container.querySelector("img");
  //   let tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: container,
  //       // toggleActions: "restart none none reset",
  //     }
  //   });

  //   if(container.classList.contains('parallax')){
  //     let tl2 = gsap.timeline({
  //       scrollTrigger: {
  //         trigger: container,
  //         scrub: true,
  //         pin: false,
  //       },
  //     });
  //     tl2.from(image, {
  //       // scaleY: 1.6,
  //       transformOrigin: "50% 50%",
  //       yPercent: -30,
  //       ease: "none",
  //     }).to(image, {
  //       transformOrigin: "50% 50%",
  //       // scale: 1.6,
  //       yPercent: 30,
  //       ease: "none",
  //     });
  //   }

  //   tl.set(container, { autoAlpha: 1 });
  //   tl.from(container, 1.5, {
  //     xPercent: -100,
  //     ease: Power2.out
  //   });
  //   tl.from(image, 1.5, {
  //     xPercent: 100,
  //     scale: 1.6,
  //     delay: -1.5,
  //     ease: Power2.out
  //   })

  // });

  // titleReveal.forEach((container) => {
  //   gsap.timeline({
  //     scrollTrigger: {
  //       trigger: container,
  //       start: "center center",
  //       // className: '+=active'
  //       toggleClass: "active",
  //       scrub: true,
  //       pin: false,
  //       // toggleActions: "restart none none reset",
  //     }
  //   });

  // })

  function tabber(activeationIndex) {
    const tabWraps = document.querySelectorAll(".js-tabs");

    tabWraps.forEach((tabWrap) => {
      const tabs = tabWrap.querySelectorAll(".tab-head_list li");
      const contents = tabWrap.querySelectorAll(".tab-content");
      const contentWrap = tabWrap.querySelector(".tab-content_wrap");
      const imgs = tabWrap.querySelectorAll(".img");

      tabs.forEach((_tab, index) => {
        if (
          activeationIndex !== false &&
          typeof activeationIndex === "number"
        ) {
          initTab(tabs, contents, activeationIndex, contentWrap, imgs);
        }

        _tab.onclick = (e) => {
          initTab(tabs, contents, index, contentWrap, imgs);
        };
      });
    });
    function initTab(tabs, contents, index, contentWrap, imgs) {
      // if(!e){
      //   return
      // }

      console.log(tabs, contents, index, contentWrap, imgs);

      let foundTab = null;
      let foundContent = null;

      tabs.forEach((tab, _index) => {
        if (index === _index) {
          foundTab = tab;
          tab.classList.add("active");
        } else {
          tab.classList.remove("active");
        }
      });

      contents.forEach((content, _index) => {
        if (index === _index) {
          foundContent = content;
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
      });

      imgs.forEach((img, _index) => {
        if (index === _index) {
          img.classList.add("active");
        } else {
          img.classList.remove("active");
        }
      });

      if (foundTab && foundContent) {
        if (contentWrap.querySelector(".noResults") !== null) {
          contentWrap.querySelector(".noResults").remove();
        }
      } else {
        const div = document.createElement("div");
        div.classList.add("active");
        div.classList.add("noResults");
        div.classList.add("tab-content");
        div.style.marginTop = "20px";
        div.innerHTML = "This tab is empty";
        if (!contentWrap.querySelector(".noResults")) {
          contentWrap.appendChild(div);
        }
      }
    }
  }

  tabber(0);

  var swiper444 = new Swiper(".swiper3", {
    spaceBetween: 10,
    slidesPerView: "auto",
    // centeredSlides: true,
    // freeMode: true,
    // watchSlidesProgress: true,
  });
  var swiper555 = new Swiper(".mySwiper2", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper444,
    },
  });

  //  AOS.init({
  //   once: true,
  // });

  // const modalizeBtns = document.querySelectorAll(".js-modalize-btn-2") || [];

  // const modalizeBtns2 = document.querySelectorAll(".js-modalize-btn") || [];

  // const modalizeCloseBtn = document.querySelector(".js-quiz-close")
  // const modalize = document.querySelector(".js-quiz-modal");

  // modalizeBtns.forEach((modalizeBtn) => {
  //   modalizeBtn.onclick = () => {
  //     modalize.classList.remove("hidden");
  //     document.body.style.overflow = "hidden";
  //   };
  // });

  // Function to remove an item from the cart
  function removeItem(line) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: line,
        quantity: 0,
      }),
    }).then((response) => response.json());
  }

  // Function to handle the click event
  // document.getElementById('remove-two-products').addEventListener('click', function() {

  // });

  const cartItems = document.querySelectorAll(".cart-item");

  let cartItemsArray = Array.from(cartItems);

  cartItems.forEach((cartItem) => {
    const removeBtn = cartItem.querySelector("div.cart-remove-button");

    const itemID = cartItem
      .querySelector(".quantity__input")
      .getAttribute("data-quantity-variant-id");

    removeBtn.onclick = () => {
      getCart()
        .then((cart) => {
          if (itemID === productsToFetch[1].id) {
            const foundTest = cart.items.find(
              (_item) => _item.id == productsToFetch[0].id,
            );

            // console.log(cart.items, foundTest)

            if (foundTest) {
              removeItem(itemID)
                .then(() => removeItem(productsToFetch[0].id))
                .then(() => {
                  location.reload();
                })
                .catch((error) => {
                  console.error("Error removing items:", error);
                });
            } else {
              removeItem(itemID).then(() => {
                location.reload();
              });
            }
          }else if (itemID === productsToFetch[2].id) {
            const foundTest = cart.items.find(
              (_item) => _item.id == productsToFetch[0].id,
            );

            // console.log(cart.items, foundTest)

            if (foundTest) {
              removeItem(itemID)
                .then(() => removeItem(productsToFetch[0].id))
                .then(() => {
                  location.reload();
                })
                .catch((error) => {
                  console.error("Error removing items:", error);
                });
            } else {
              removeItem(itemID).then(() => {
                location.reload();
              });
            }
          } else {
            const IDtoNumber = Number(itemID);
            removeItem(itemID).then(() => {
              location.reload();
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching cart:", error);
        });
    };

    // removeBtn.addEventListener('click', (e) => {
    //   console.log("AAA",itemID)
    //   const findTest = cartItemsArray.find(_arr_item => {

    //     const _arr_item_ID = _arr_item.querySelector('.quantity__input').getAttribute('data-quantity-variant-id')
    //     if(_arr_item.id !== itemID && itemID === productsToFetch[1].id && _arr_item_ID === productsToFetch[0].id){
    //       return _arr_item
    //     }
    //     return false;
    //   })

    //   if(findTest){
    //      const _foundTestRemoveBtn = findTest.querySelector('cart-remove-button')

    //     if(_foundTestRemoveBtn){
    //       _foundTestRemoveBtn.click()
    //       removeBtn.click()
    //     }
    //   }

    // })
  });
});

async function addToCart(productId, quantity, callback) {
  try {
    const product = productsToFetch.find(
      (item) => Number(item.id) == Number(productId),
    );

    const cart = await getCart();

    const foundTestProduct = cart.items.find(
      (cartItems) => cartItems.id == productsToFetch[0].id,
    );

    const foundMemershipProduct = cart.items.find(
      (cartItems) => cartItems.id == productsToFetch[1].id,
    );

    const isTestProduct = product.id === productsToFetch[0].id;

    const isMembershipProduct = product.id === productsToFetch[1].id;

    let response = null;

    if (
      (!foundTestProduct && isTestProduct) ||
      (!foundMemershipProduct && isMembershipProduct)
    ) {
      response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: [product] }),
      });
    }

    // { id: productId, quantity: quantity };

    if (response && !response.ok) {
      throw new Error("Network response was not ok");
      const data = await response.json();
      console.log("Product added to cart:", data);
      if (typeof callback === "function") {
        callback(null, data);
      }
      return data;
    } else {
      if (typeof callback === "function") {
        callback(null, null);
      }
      return null;
    }
  } catch (error) {
    console.error("Error:", error);

    // Call the callback function with the error if it's provided
    if (typeof callback === "function") {
      callback(error, null);
    }

    throw error; // Re-throw the error for further handling if needed
  }
}

async function addTestAndSubToCart() {
  try {
    // { id: productId, quantity: quantity };

    const cart = await getCart();

    const foundTestProduct = cart.items.find(
      (cartItems) => cartItems.id == productsToFetch[0].id,
    );

    const foundMemershipProduct = cart.items.find(
      (cartItems) => cartItems.id == productsToFetch[1].id,
    );

    const somethingWasFound =
      foundTestProduct || foundMemershipProduct || false;

    let response = null;

    if (somethingWasFound) {
      if (foundTestProduct && !foundMemershipProduct) {
        response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [productsToFetch[1]] }),
        });
      }

      if (foundMemershipProduct && !foundTestProduct) {
        response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [productsToFetch[0]] }),
        });
      }
    } else {
      response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [productsToFetch[0], productsToFetch[1]],
        }),
      });
    }

    if (response) {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Product added to cart:", data);

      // Call the callback function with the data if it's provided
      if (typeof callback === "function") {
        callback(null, data);
      }

      return data;
    } else {
      if (typeof callback === "function") {
        callback(null, null);
      }
      return null;
    }
  } catch (error) {
    console.error("Error:", error);

    // Call the callback function with the error if it's provided
    if (typeof callback === "function") {
      callback(error, null);
    }

    throw error; // Re-throw the error for further handling if needed
  }
}

async function addYearlyMemberAndTest() {
  try {
    // { id: productId, quantity: quantity };

    const cart = await getCart();

    const foundTestProduct = cart.items.find(
      (cartItems) => cartItems.id == productsToFetch[0].id,
    );

    const foundMemershipProduct = cart.items.find(
      (cartItems) => cartItems.id == productsToFetch[2].id,
    );

    const somethingWasFound =
      foundTestProduct || foundMemershipProduct || false;

    let response = null;

    if (somethingWasFound) {
      if (foundTestProduct && !foundMemershipProduct) {
        response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [productsToFetch[2]] }),
        });
      }

      if (foundMemershipProduct && !foundTestProduct) {
        response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [productsToFetch[0]] }),
        });
      }
    } else {
      response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [productsToFetch[0], productsToFetch[2]],
        }),
      });
    }

    if (response) {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Product added to cart:", data);

      // Call the callback function with the data if it's provided
      if (typeof callback === "function") {
        callback(null, data);
      }

      return data;
    } else {
      if (typeof callback === "function") {
        callback(null, null);
      }
      return null;
    }
  } catch (error) {
    console.error("Error:", error);

    // Call the callback function with the error if it's provided
    if (typeof callback === "function") {
      callback(error, null);
    }

    throw error; // Re-throw the error for further handling if needed
  }
}

async function addOnlyYearlyMember() {
  await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: [productsToFetch[2]] }),
  });
}

async function handleClickToAddProduct(callback) {
  await addToCart(productsToFetch[1].id, 1, callback);
}

window.addEventListener("DOMContentLoaded", () => {
  let lastScrollPosition = { x: 0, y: 0 };

  document.addEventListener("focusin", function (e) {
    if (e.target.classList.contains("no-scroll-focus")) {
      lastScrollPosition.x = window.pageXOffset;
      lastScrollPosition.y = window.pageYOffset;
    }
  });

  document.addEventListener("focusout", function (e) {
    if (e.target.classList.contains("no-scroll-focus")) {
      setTimeout(() => {
        window.scrollTo(lastScrollPosition.x, lastScrollPosition.y);
      }, 0);
    }
  });

  // let quizHistory = [];

  // const modalizeCloseBtn = document.querySelector(".js-quiz-close");

  // const jsBar = document.querySelector(".js-quiz-bar");
  // const jsBarLabel = document.querySelector(".js-quiz-progress");
  // const jsBarWrap = document.querySelector(".js-quiz-bar-wrap");
  // const SlidesWithProp = document.querySelectorAll(
  //   ".quiz_swiper .swiper-slide",
  // );

  // const quiz_swiper = new Swiper(".quiz_swiper", {
  //   speed: 0,
  //   allowTouchMove: false,
  //   // effect: "fade",
  //   autoHeight: true,

  //   navigation: {
  //     nextEl: ".quiz-next-custom",
  //     prevEl: ".quiz-prev-custom",
  //   },
  //   pagination: {
  //     el: ".quiz_pagintaion",
  //     type: "fraction",
  //   },
  //   breakpoints: {
  //     768: {
  //       // effect: "fade",
  //       // speed: 200,
  //     },
  //   },
  //   on: {
  //     slideChange: function () {
  //       jsBar.style.width = `${this.progress * 100}%`;
  //       jsBarLabel.innerHTML = `${Math.ceil(this.progress * 100)}%`;

  //       // console.log(
  //       //   SlidesWithProp[this.activeIndex].classList.contains("progress-slide"),
  //       //   this.activeIndex,
  //       //   "sss",
  //       // );

  //       if (
  //         !SlidesWithProp[this.activeIndex].classList.contains("progress-slide")
  //       ) {
  //         jsBarWrap.style.display = "none";
  //       } else {
  //         jsBarWrap.style.display = "flex";
  //       }
  //     },
  //   },
  // });

  // if (
  //   !SlidesWithProp[quiz_swiper.activeIndex].classList.contains(
  //     "progress-slide",
  //   )
  // ) {
  //   jsBarWrap.style.display = "none";
  // }

  // const quizForm = document.querySelector(".quiz__iframe");

  // let cart_item_count = 0;

  // if (quizForm && quiz_swiper ) {
  //   quizForm.reset();
  //   async function fetchCartDetails() {
  //     await fetch("/cart.js")
  //       .then((response) => response.json())
  //       .then((cart) => {
  //         console.log("Cart details:", cart);
  //         displayCartDetails(cart);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching cart details:", error);
  //       });
  //   }

  //   // Function to display cart details in the HTML
  //   function displayCartDetails(cart) {
  //     cart_item_count = cart.item_count;
  //   }
  //   fetchCartDetails();
  //   // Fetch and display cart details on page load

  //   const modalize2 = quizForm.closest(".js-quiz-modal");

  //   const result = quizForm.querySelector(".result");

  //   const slides = modalize2.querySelectorAll(".swiper-slide");

  //   slides.forEach((slide, _slideIndex) => {
  //     const arrInputs = [];
  //     const inputsInSlide = slide.querySelectorAll("input") || [];
  //     const nextBtn = slide.querySelector(".js-next");
  //     const nodeArray = Array.from(inputsInSlide);

  //     const backBtn = slide.querySelector(".js-quiz-back-btn");

  //     if (
  //       backBtn &&
  //       quizHistory.length == 0 &&
  //       quiz_swiper.activeIndex == 0 &&
  //       _slideIndex == 0
  //     ) {
  //       backBtn.style.opacity = 0;
  //       backBtn.style.pointerEvents = "none";
  //     }

  //     let haveErrorInSlide = false;

  //     let inputName = "";

  //     let haveEmailInput = false;

  //     for (let i = 0; i < inputsInSlide.length; i++) {
  //       const element00 = inputsInSlide[i];
  //       console.log(element00.type);
  //       if (element00.name === "email") {
  //         haveEmailInput = true;
  //       }
  //     }

  //     const errorDiv = slide.querySelector(".js-error");

  //     const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //     const passwordPattern = /^.{6,}$/;

  //     function validateEmail(email) {
  //       return emailPattern.test(email);
  //     }

  //     function validatePassword(password) {
  //       return passwordPattern.test(password);
  //     }

  //     inputsInSlide.forEach((inputInSlide, inputIndex) => {
  //       const inputPayload = {
  //         type: inputInSlide.type,
  //         name: inputInSlide.name,
  //         flag: false,
  //         skipSteps: 1,
  //       };

  //       if (
  //         (inputInSlide.type == "radio" || inputInSlide.type == "checkbox") &&
  //         inputName !== inputInSlide.name
  //       ) {
  //         arrInputs.push(inputPayload);
  //         inputName = inputInSlide.name;
  //       }

  //       if (
  //         inputInSlide.type == "password" ||
  //         inputInSlide.type == "text" ||
  //         inputInSlide.type == "number"
  //       ) {
  //         arrInputs.push(inputPayload);
  //       }

  //       // inputInSlide.onclick = ({target} = e) => {
  //       // target.blur()
  //       // e.preventDefault();
  //       // this.blur();
  //       // }

  //       inputInSlide.focus = (e) => {
  //         e.preventDefault;
  //         let scrollX = window.pageXOffset;
  //         let scrollY = window.pageYOffset;

  //         // Set timeout to restore scroll position
  //         setTimeout(function () {
  //           window.scrollTo(scrollX, scrollY);
  //         }, 0);
  //       };

  //       inputInSlide.oninput = (e) => {
  //         let indexAA = 0;

  //         // UndisableAll()

  //         const foundObj = arrInputs.find((item, _indexAA) => {
  //           if (e.target.name === item.name) {
  //             indexAA = _indexAA;
  //             return item;
  //           }
  //         });

  //         if (e.target.value.length > 0) {
  //           arrInputs[indexAA].flag = true;
  //         } else {
  //           arrInputs[indexAA].flag = false;
  //         }

  //         if (inputInSlide.type == "radio") {
  //           arrInputs[indexAA].skipSteps =
  //             inputInSlide.getAttribute("skip-steps-count") &&
  //             inputInSlide.getAttribute("skip-steps-count") !== ""
  //               ? Number(inputInSlide.getAttribute("skip-steps-count"))
  //               : 1;
  //         }

  //         let stepChecker = true;

  //         arrInputs.forEach((arrInput) => {
  //           if (arrInput.flag && stepChecker) {
  //           } else {
  //             stepChecker = false;
  //           }
  //         });

  //         if (!stepChecker) {
  //           DisableOnErr();
  //         }

  //         if (stepChecker && nextBtn) {
  //           UndisableAll();

  //           const formData = new FormData(quizForm);

  //           let inputFlag = false;

  //           if (haveEmailInput) {
  //             if (!validateEmail(formData.get("email"))) {
  //               DisableOnErr("Invalid email");
  //               inputFlag = true;
  //             }
  //             // if (!validatePassword(formData.get("password"))) {
  //             //   DisableOnErr("Invalid password");
  //             //   inputFlag = true;
  //             // }
  //           }

  //           let slideHaveNumberType = false;
  //           let counterInner = 0;

  //           for (let i = 0; i < inputsInSlide.length; i++) {
  //             const element00 = inputsInSlide[i];
  //             console.log(element00.type);
  //             if (element00.type === "number") {
  //               slideHaveNumberType = true;
  //               counterInner = i;
  //             }
  //           }

  //           if (
  //             slideHaveNumberType &&
  //             formData.get(inputsInSlide[counterInner].name)
  //           ) {
  //             if (formData.get(inputsInSlide[counterInner].name) < 18) {
  //               DisableOnErr("You must be over 18 years of age");
  //             }

  //             if (formData.get(inputsInSlide[counterInner].name) >= 100) {
  //               DisableOnErr("Please enter your age (18-99)");
  //             }
  //           }

  //           if (inputInSlide.type == "checkbox") {
  //             const checkboxes = document.querySelectorAll(
  //               `input[name="${inputInSlide.name}"]`,
  //             );
  //             const maxAllowed = 3;
  //             const checkedCheckboxes = document.querySelectorAll(
  //               `input[name="${inputInSlide.name}"]:checked`,
  //             );
  //             if (checkedCheckboxes.length > maxAllowed) {
  //               e.target.checked = false;
  //               DisableOnErr("Selected maximum number of options", false);
  //               // errorDiv.innerHTML = 'Selected maximum number of options'
  //             }
  //           }

  //           // nextBtn.classList.add('disabled')
  //           // nextBtn.style.display = 'inline-flex'
  //           nextBtn.onclick = () => {
  //             const stepper = arrInputs[indexAA].skipSteps || 1;
  //             const y = quiz_swiper.activeIndex + stepper;
  //             quizHistory.push(stepper);
  //             if (!haveErrorInSlide) {
  //               quiz_swiper.slideTo(y);
  //             }
  //             // quiz_swiper.updateAutoHeight();
  //             // quiz_swiper.updateSize();
  //           };

  //           quizForm.onkeypress = () => {
  //             if (event.key === "Enter") {
  //               event.preventDefault();
  //               if (!haveErrorInSlide) {
  //                 nextBtn.click();
  //               }
  //             }
  //           };
  //         } else if (nextBtn) {
  //           nextBtn.onclick = () => {
  //             DisableOnErr("Fill all inputs in current step");
  //           };
  //         }

  //         function DisableOnErr(text = "", flag = true) {
  //           haveErrorInSlide = flag;

  //           if (text.length > 0) {
  //             errorDiv.innerHTML = text;
  //           }
  //           if (haveErrorInSlide) {
  //             nextBtn.classList.add("disabled");
  //           } else {
  //             nextBtn.classList.remove("disabled");
  //           }
  //           quiz_swiper.updateAutoHeight();
  //         }
  //         function UndisableAll() {
  //           errorDiv.innerHTML = "";
  //           nextBtn.classList.remove("disabled");
  //           quiz_swiper.updateAutoHeight();
  //           haveErrorInSlide = false;
  //         }
  //       };
  //     });

  //     quizForm.onkeydown = (ev) => {
  //       if (ev.keyCode === 9) {
  //         event.preventDefault();
  //       }
  //     };

  //     if (backBtn) {
  //       backBtn.onclick = () => {
  //         if (quizHistory.length > 0) {
  //           const currentSlide = quiz_swiper.activeIndex;
  //           quiz_swiper.slideTo(
  //             currentSlide - quizHistory[quizHistory.length - 1],
  //           );
  //           quizHistory.pop();
  //         }
  //       };
  //     }

  //     //     modalizeCloseBtn.addEventListener('click', ()=> {
  //     //     arrInputs.forEach(input => {
  //     //       input.flag = false
  //     //     })

  //     //     document.body.style.overflow = 'unset'

  //     //     let stepChecker = true

  //     //     arrInputs.forEach(arrInput => {
  //     //       if(arrInput.flag && stepChecker){

  //     //       }else{
  //     //         stepChecker = false
  //     //       }
  //     //     })

  //     //     if(stepChecker && nextBtn){
  //     //       nextBtn.classList.add('disabled')
  //     //       // nextBtn.onclick = () => {
  //     //       //   quiz_swiper.slideNext()
  //     //       // }
  //     //     }else if (nextBtn){
  //     //       nextBtn.classList.remove('disabled')
  //     //       // nextBtn.onclick = () => {
  //     //       // }
  //     //     }

  //     //     quiz_swiper.updateAutoHeight()
  //     // })

  //     modalizeCloseBtn.addEventListener("click", () => {
  //       inputsInSlide.forEach((inputInSlide) => {
  //         // inputInSlide.value = null
  //         quizForm.reset();
  //         modalize2.classList.add("hidden");
  //         quiz_swiper.slideTo(0);
  //         quizHistory.length = 0;
  //       });

  //       arrInputs.forEach((input) => {
  //         input.flag = false;
  //       });

  //       document.body.style.overflow = "unset";

  //       let stepChecker = true;

  //       arrInputs.forEach((arrInput) => {
  //         if (arrInput.flag && stepChecker) {
  //         } else {
  //           stepChecker = false;
  //         }
  //       });

  //       nextBtn.classList.add("disabled");
  //     });

  //     // const nextBtn = slide.querySelectorAll('.js-next')
  //   });
  //   // quizForm.onkeypress = () => {
  //   //   if (event.key === "Enter") {
  //   //     event.preventDefault();
  //   //   }
  //   // }
  //   quizForm.addEventListener("submit", async (event) => {
  //     event.preventDefault();

  //     quizForm.querySelectorAll(".js-next").forEach((btn) => {
  //       btn.classList.add("disabled");
  //     });

  //     const formData = new FormData(event.currentTarget);
  //     const defaultLastname = "-";

  //     const emailValue = formData.get("email").trim();
  //     const emailFirstName = formData.get("firstname").trim();

  //     // && emailFirstName == ""

  //     if (emailValue == "" && emailFirstName == "") return;

  //     const confirmFlag = formData.get(`confirm`);

  //     if (
  //       !confirmFlag &&
  //       event.currentTarget.querySelector('[name="confirm"]')
  //     ) {
  //       alert("Please check this box if you want ot preceed", confirmFlag);
  //       return;
  //     }

  //     const formObject = Object.fromEntries(formData.entries());

  //     const answerKeys = Object.keys(formObject).filter((key) => {
  //       if (
  //         key !== "email" &&
  //         key !== "firstname" &&
  //         key !== "password" &&
  //         !key.includes("q_") &&
  //         key !== "confirm"
  //       ) {
  //         return key;
  //       }
  //     });

  //     const answerValues = (key) =>
  //       JSON.parse(formData.get(`q_${key}_anserw_value_variants`)).filter(
  //         (item) => {
  //           if (item !== "") return true;
  //           return false;
  //         },
  //       );

  //     const getCheckboxValues = (key) => {
  //       return Array.from(formData.getAll(`${key}`)).filter(
  //         (value) => value !== "",
  //       );
  //     };

  //     const newNotes = answerKeys.map((answerKey) => {
  //       // Check if the question is a checkbox type
  //       const questionType = formData.get(`q_${answerKey}_question_type`);
  //       let answer;

  //       if (questionType === "checkbox") {
  //         // If it's a checkbox, get all checked values
  //         answer = JSON.stringify(getCheckboxValues(answerKey));
  //       } else {
  //         // Otherwise, get the single answer value
  //         answer = formData.get(answerKey);
  //       }

  //       return {
  //         question: formData.get(`q_${answerKey}`),
  //         answer: answer,
  //         answerValues: JSON.stringify(answerValues(answerKey)),
  //         questionType: questionType,
  //       };
  //     });

  //     const customerData = {
  //       customer: {
  //         email: formData.get("email"),
  //         first_name: formData.get("firstname") || "",
  //         last_name: defaultLastname,
  //         note: JSON.stringify(newNotes),
  //         metafields: [
  //           {
  //             key: "test_status",
  //             value: "New",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "b6_5_",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "b9_folic_acid",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "b12_methylcobalamine",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "vitamin_c_ascorbic_acid",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "vitamin_d3_cholecalciferol",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "calcium_carbonate",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "iron_bisglycinate",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "magnesium_bisglycinate",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "selenomethionine",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //           {
  //             key: "zinc_bisglycinate",
  //             value: "-",
  //             type: "single_line_text_field",
  //             namespace: "custom",
  //           },
  //         ],
  //       },
  //     };
  //     // const BackendServer = "http://silverspoon.studio:3000/proxy";
  //     const BackendServer =
  //       "https://node-back-aurea-2e1aa9b94062.herokuapp.com/proxy";
  //     const url2 = `https://clubaurea.com/admin/api/2024-01/customers/search.json?query=email%3A${customerData.customer.email}`;
  //     const url3 = `${BackendServer}?url=https://clubaurea.com/admin/api/2024-01/customers/search.json?query=email%3A${customerData.customer.email}&method=GET&useShopifyAuth=true`;

  //     const shopName = "e7098f-02.myshopify.com";

  //     // const addProductForm = document.querySelector('form.formToAddProduct')
  //     const addProductForm2 = document.querySelector("form.formToAddProduct2");

  //     // const authForm = document.querySelector('form.formToAuth')

  //     await fetch(url3, { method: "GET" })
  //       .then((response) => response.json())
  //       .then(async (data) => {
  //         console.log("customers found:", data);

  //         if (data.customers.length > 0) {
  //           const { customers } = data;

  //           const foundCustomer = customers.find((customerDataInLoop) => {
  //             if (
  //               customerDataInLoop.first_name ===
  //               customerData.customer.first_name
  //             ) {
  //               return customerDataInLoop;
  //             }
  //           });

  //           if (foundCustomer) {
  //             console.log("customer was found ", foundCustomer);

  //             // need to check if metafields are putted

  //             let newCustomerMetafields = foundCustomer?.metafields
  //               ? foundCustomer.metafields
  //               : customerData.customer.metafields;

  //             let datakkk = { ...foundCustomer };

  //             datakkk.note = customerData.customer.note;

  //             const urlUrl = `${BackendServer}?url=https://clubaurea.com/admin/api/2024-01/customers/${foundCustomer.id}/metafields.json&method=GET&useShopifyAuth=true`;
  //             // `https://${shopName}.myshopify.com/admin/api/2024-01/customers/${foundCustomer.id}/metafields.json`

  //             let foundmetafields = null;

  //             await fetch(urlUrl, { method: "GET" })
  //               .then((response) => response.json())
  //               .then(async (data2) => {
  //                 foundmetafields = data2;
  //                 console.log("customer metafelds were found:", data2);
  //               });

  //             console.log(
  //               "customer metafelds were found2323:",
  //               foundmetafields,
  //             );

  //             const CustomerNewData = {
  //               customer: {
  //                 first_name: customerData.customer.first_name,
  //                 last_name: customerData.customer.last_name,
  //                 email: customerData.customer.email,
  //                 verified_email: true,
  //                 note: customerData.customer.note,
  //                 password: "newpass",
  //                 password_confirmation: "newpass",
  //                 send_email_welcome: true,
  //                 metafields: customerData.customer.metafields,
  //               },
  //             };

  //             if (foundmetafields.metafields.length == 0) {
  //               // const resetMetafieldUrl = `https://${shopName}.myshopify.com/admin/api/2024-01/customers/${foundCustomer.id}/metafields.json`;

  //               CustomerNewData.customer.metafields.forEach(
  //                 async (_metafield) => {
  //                   const JSON_TO_STRINGBBB = JSON.stringify({
  //                     metafield: _metafield,
  //                   });

  //                   const PrepareBody = {
  //                     method: "POST",
  //                     useShopifyAuth: true,
  //                     url: `https://${shopName}/admin/api/2024-01/customers/${foundCustomer.id}/metafields.json`,
  //                     body: {
  //                       metafield: _metafield,
  //                     },
  //                   };

  //                   const encodedBody = encodeURIComponent(PrepareBody);

  //                   const resetMetafieldUrl2 = `${BackendServer}?url=https://clubaurea.com/admin/api/2024-01/customers/${foundCustomer.id}/metafields.json`;

  //                   console.log(resetMetafieldUrl2);

  //                   await fetch(resetMetafieldUrl2, {
  //                     method: "POST",
  //                     headers: {
  //                       "Content-Type": "application/json",
  //                     },
  //                     body: JSON.stringify(PrepareBody),
  //                   })
  //                     .then(async () => {
  //                       // console.log("customer was created foundmetafields.length" , foundmetafields.length)
  //                       modalize2.classList.add("hidden");
  //                       quiz_swiper.slideTo(0);
  //                       const slideForms = event.srcElement.querySelectorAll(
  //                         ".swiper-slide.progress-slide",
  //                       );

  //                       const lastSlide = slideForms[slideForms.length - 2];
  //                       const _lastSlide = slideForms[slideForms.length - 1];

  //                       const lastSlideInput = lastSlide.querySelector(
  //                         ".radio_wrap_outer input",
  //                       );

  //                       const lastSlideInputAnserw = formData.get(
  //                         lastSlideInput.name,
  //                       );

  //                       const _lastSlideInput = _lastSlide.querySelector(
  //                         ".radio_wrap_outer input",
  //                       );

  //                       const _lastSlideInputAnserw = formData.get(
  //                         _lastSlideInput.name,
  //                       );

  //                       // addProductForm.addEventListener("submit",()=>{

  //                       // })

  //                       if (lastSlideInputAnserw.includes("Yes,")) {
  //                         // with test
  //                         // const productIdInput = addProductForm.querySelector('input[name="id"]')
  //                         // productIdInput.value = '49656648270140'
  //                         if (_lastSlideInputAnserw == "Monthly") {
  //                           await addTestAndSubToCart();
  //                         } else if (_lastSlideInputAnserw == "Yearly") {
  //                           await addYearlyMemberAndTest();
  //                         }

  //                         window.location.href = "/cart";

  //                         // await addToCart(productsToFetch[0].id , 1)

  //                         // await addToCart(productsToFetch[1].id, 1);

  //                         // window.location.href = '/cart';

  //                         // handleClickToAddProduct(()=>addToCart(productsToFetch[1].id, 1, () => {window.location.href = '/cart'}))
  //                         // addProductForm2.submit();

  //                         // addProductForm2.submit()
  //                       } else {
  //                         if (_lastSlideInputAnserw == "Monthly") {
  //                           await addToCart(productsToFetch[1].id, 1);
  //                         } else if (_lastSlideInputAnserw == "Yearly") {
  //                           // await addToCart(productsToFetch[2].id, 1);
  //                           await addOnlyYearlyMember()
  //                         }

  //                         window.location.href = "/cart";

  //                         // addToCart(productsToFetch[1].id, 1,() => {window.location.href = '/cart'})
  //                         // addProductForm2.submit();
  //                       }
  //                     })
  //                     .catch((error) => {
  //                       alert("Something's wrong");
  //                       quizForm.querySelectorAll(".js-next").forEach((btn) => {
  //                         btn.classList.remove("disabled");
  //                       });
  //                       console.log("customer was not created", error);
  //                     });
  //                 },
  //               );
  //             } else {
  //               let findAndReplace = null;

  //               if (foundmetafields !== null && foundmetafields) {
  //                 findAndReplace = foundmetafields.metafields.map(
  //                   (foundmetafield) => {
  //                     if (foundmetafield.key == "test_status") {
  //                       foundmetafield.value = "Updated";
  //                     }
  //                     return foundmetafield;
  //                   },
  //                 );
  //               }

  //               let CustomerNewDataAA = {
  //                 customer: {
  //                   ...foundCustomer,
  //                   note: customerData.customer.note,
  //                   metafields: foundmetafields.metafields,
  //                 },
  //               };
  //               const JSON_TO_STRINGAA = JSON.stringify(CustomerNewDataAA);

  //               const PrepareBody3 = {
  //                 method: "PUT",
  //                 url: `https://${shopName}/admin/api/2024-01/customers/${foundCustomer.id}.json`,
  //                 useShopifyAuth: true,
  //                 body: CustomerNewDataAA,
  //               };

  //               const encodedBody3 = encodeURIComponent(PrepareBody3);

  //               // const urlToUpdateNotes = `https://${shopName}.myshopify.com/admin/api/2024-01/customers/${foundCustomer.id}.json`;
  //               // const urlToUpdateNotes2 = `${BackendServer}?url=https://clubaurea.com/admin/api/2024-01/customers/${foundCustomer.id}.json`;

  //               await fetch(BackendServer, {
  //                 method: "POST",
  //                 headers: {
  //                   "Content-Type": "application/json",
  //                 },
  //                 body: JSON.stringify(PrepareBody3),
  //               })
  //                 .then(async () => {
  //                   console.log("data was updated well");
  //                   modalize2.classList.add("hidden");
  //                   quiz_swiper.slideTo(0);

  //                   const slideForms = event.srcElement.querySelectorAll(
  //                     ".swiper-slide.progress-slide",
  //                   );

  //                   const lastSlide = slideForms[slideForms.length - 2];
  //                   const _lastSlide = slideForms[slideForms.length - 1];

  //                   const lastSlideInput = lastSlide.querySelector(
  //                     ".radio_wrap_outer input",
  //                   );

  //                   const lastSlideInputAnserw = formData.get(
  //                     lastSlideInput.name,
  //                   );

  //                   const _lastSlideInput = _lastSlide.querySelector(
  //                     ".radio_wrap_outer input",
  //                   );

  //                   const _lastSlideInputAnserw = formData.get(
  //                     _lastSlideInput.name,
  //                   );

  //                   if (lastSlideInputAnserw.includes("Yes,")) {
  //                     if (_lastSlideInputAnserw == "Monthly") {
  //                       await addTestAndSubToCart();
  //                     } else if (_lastSlideInputAnserw == "Yearly") {
  //                       await addYearlyMemberAndTest();
  //                     }

  //                     window.location.href = "/cart";
  //                   } else {
  //                     // addToCart(productsToFetch[1].id, 1, () => {window.location.href = '/cart'})
  //                     // addProductForm2.submit();
  //                     // await addToCart(productsToFetch[1].id, 1);

  //                     if (_lastSlideInputAnserw == "Monthly") {
  //                       await addToCart(productsToFetch[1].id, 1);
  //                     } else if (_lastSlideInputAnserw == "Yearly") {
  //                       // await addToCart(productsToFetch[2].id, 1);
  //                       await addOnlyYearlyMember()
  //                     }

  //                     window.location.href = "/cart";
  //                   }
  //                 })
  //                 .catch((error) => {
  //                   console.log(
  //                     "have error in request to update data: ",
  //                     error,
  //                   );
  //                 });
  //             }
  //           } else {
  //             alert(
  //               "A user with this email account already exists. Please enter the correct first name or use a different email.",
  //             );
  //             quizForm.querySelectorAll(".js-next").forEach((btn) => {
  //               btn.classList.remove("disabled");
  //             });
  //             // console.log("customer was not found ", foundCustomer);
  //           }
  //         } else {
  //           const CustomerNewDataAAA = {
  //             customer: {
  //               first_name: customerData.customer.first_name,
  //               last_name: customerData.customer.last_name,
  //               email: customerData.customer.email,
  //               verified_email: true,
  //               note: customerData.customer.note,
  //               password: formData.get("password"),
  //               password_confirmation: formData.get("password"),
  //               send_email_welcome: true,
  //               metafields: customerData.customer.metafields,
  //             },
  //           };

  //           // const urlToCreateAcc = `https://${shopName}.myshopify.com/admin/api/2024-01/customers.json`;

  //           const JSON_TO_STRINGAAA = JSON.stringify(CustomerNewDataAAA);

  //           const PrepareBody2 = {
  //             method: "POST",
  //             useShopifyAuth: true,
  //             url: `https://${shopName}/admin/api/2024-01/customers.json`,
  //             body: CustomerNewDataAAA,
  //           };

  //           const encodedBody2 = encodeURIComponent(PrepareBody2);

  //           // const urlToCreateAcc2 = `${BackendServer}?url=https://clubaurea.com/admin/api/2024-01/customers.json&method=POST&useShopifyAuth=true&body=${JSON_TO_STRINGAAA}`;

  //           await fetch(BackendServer, {
  //             method: "POST",
  //             headers: {
  //               "Content-Type": "application/json",
  //             },
  //             body: JSON.stringify(PrepareBody2),
  //           })
  //             .then(async () => {
  //               console.log("customer was created");
  //               // modalize2.classList.add('hidden')
  //               // quiz_swiper.slideTo(0)

  //               // authForm.querySelector('input[name="customer[email]"]').value = customerData.customer.email
  //               // authForm.querySelector('input[name="customer[password]"]').value = formData.get('password')

  //               const slideForms = event.srcElement.querySelectorAll(
  //                 ".swiper-slide.progress-slide",
  //               );

  //               const lastSlide = slideForms[slideForms.length - 2];
  //               const _lastSlide = slideForms[slideForms.length - 1];

  //               const lastSlideInput = lastSlide.querySelector(
  //                 ".radio_wrap_outer input",
  //               );

  //               const lastSlideInputAnserw = formData.get(lastSlideInput.name);

  //               const _lastSlideInput = _lastSlide.querySelector(
  //                 ".radio_wrap_outer input",
  //               );

  //               const _lastSlideInputAnserw = formData.get(
  //                 _lastSlideInput.name,
  //               );

  //               if (lastSlideInputAnserw.includes("Yes,")) {
  //                 if (_lastSlideInputAnserw == "Monthly") {
  //                   await addTestAndSubToCart();
  //                 } else if (_lastSlideInputAnserw == "Yearly") {
  //                   await addYearlyMemberAndTest();
  //                 }

  //                 window.location.href = "/cart";
  //               } else {
  //                 if (_lastSlideInputAnserw == "Monthly") {
  //                   await addToCart(productsToFetch[1].id, 1);
  //                 } else if (_lastSlideInputAnserw == "Yearly") {
  //                   await addOnlyYearlyMember()
  //                   // await addToCart(productsToFetch[2].id, 1);
  //                 }

  //                 window.location.href = "/cart";
  //               }
  //             })
  //             .catch((error) => {
  //               console.log("customer was not created", error);
  //               alert("Something's wrong. Your account has not been created");
  //               quizForm.querySelectorAll(".js-next").forEach((btn) => {
  //                 btn.classList.remove("disabled");
  //               });
  //             });

  //           // create and set notes
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("have error in first request: ", error);
  //       });
  //   });
  // }
});
